"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pricing = void 0;
const Base_1 = require("./Base");
const index_1 = require("../index");
class Pricing extends Base_1.Base {
    name = '';
    description = '';
    fn = '';
    start = null;
    end = null;
    readonly = false;
    components = null;
    metadata = {};
    _m = ['components', 'name', 'metadata'];
    constructor(data, olMap, type, idLen) {
        super(type || 'pricing', idLen || 7);
        (0, index_1.setObjectProperties)(this, data, olMap, Pricing);
    }
    toString() {
        return `Pricing: ${this.name}: ${this.description}`;
    }
}
exports.Pricing = Pricing;
index_1.olm.pricing = (ref, map) => {
    return new Pricing(ref, map);
};
